// extracted by mini-css-extract-plugin
export default {"slot":"Slot_slot__pmG2M","slotButton":"Slot_slotButton__Yd-Ky","slotButtonActive":"Slot_slotButtonActive__PE5VU"};